import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import onlineC from "../media/img/onlineC.png";
//import onlineVideo from "../media/img/onlineVideo.png";
//import assessmentBooks from "../media/img/assessmentBooks.png";
import { Helmet } from "react-helmet-async"; // ✅ Import Helmet

const onlineC = "/media/img/onlineC.png";
const onlineVideo = "/media/img/onlineVideo.png";
const assessmentBooks = "/media/img/assessmentBooks.png";

const ServicesPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const listItems = [
    "Application Support: Navigate the application process with ease, including form completion and guidance on submission.",
    "Scholarships & Financial Aid: Identify and apply for scholarships and financial aid opportunities.",
    "Personal Statement Help: Craft standout personal statements and statements of purpose with expert advice.",
    "Recommendation Letters: Access templates and tips for securing and writing impactful recommendation letters.",
    "Document Management: Ensure all required documents are collected, verified, and organized for submission.",
    "Entrance Exam Prep: Receive resources and tutoring for exams such as SAT, GRE, TOEFL, and IELTS.",
    "Interview Coaching: Prepare with mock interviews and expert advice for admissions interviews.",
    "Program Selection Guidance: Choose the right course or program aligned with your career aspirations.",
    "Deadline Tracking: Stay on top of important application deadlines with tailored timelines and reminders.",
    "International Applications: Support for applying to universities abroad, including visa and immigration assistance.",
    "Post-Application Follow-up: Guidance for communicating with universities and handling the post-application process.",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 < listItems.length ? prevIndex + 1 : 0
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [listItems.length]);

  return (
      <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Our Services, SPK Academy & Publishing</title>
        <meta
          name="description"
          content="SPK Academy offers assessment books, online lessons, video lessons, printing, graphic design, and post-matric support for students and creatives."
        />
        <meta property="og:title" content="Our Services, SPK Academy & Publishing" />
        <meta property="og:description" content="Explore SPK Academy's wide range of educational and creative services." />
        <meta property="og:url" content="https://spkrobertacademy.com/services" />
        <meta name="robots" content="index, follow" />
      </Helmet>

  <section className="pb-6 pt-16" id="featured-services">

      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-3 sm:my-3 bg-gray-600 rounded-xl p-4">
          What We Offer
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-3">
          {/* Assessment Books */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-2">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Assessment Books
              </h3>
              <p className="text-gray-600 mb-4">
                Provide term-by-term practice in Mathematics and Physical Sciences,
                aligned with the curriculum. Students can purchase books alone or
                with marking services for personalized feedback.
              </p>
              <img
                src={assessmentBooks}
                alt="Assessment Books"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <Link
                to="/books"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link>
            </div>
          </div>

          {/* Online Lessons */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-2">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Online Lessons
              </h3>
              <p className="text-gray-600 mb-4">
                Offer interactive lessons in Mathematics and Physical Sciences via
                Zoom, with options for group or one-on-one sessions. Classes include
                assessment books, marking, and feedback to support learning.
              </p>
              <img
                src={onlineC}
                alt="Online Lessons"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <Link
                to="/classes"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link>
            </div>
          </div>

          {/* Video Lessons */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-4">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Video Lessons
              </h3>
              <p className="text-gray-600 mb-4">
                Provide pre-recorded content, allowing students to learn at their
                own pace. The package includes assessment books, marking services,
                and feedback through Google Classroom.
              </p>
              <img
                src={onlineVideo}
                alt="Video Lessons"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <Link
                to="/classes"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link>
            </div>
          </div>

          {/* Printing */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-2">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Printing
              </h3>
              <p className="text-gray-600 mb-4">
                Our professional printing services cover everything from business
                cards to large prints. Discover more about our printing options.
              </p>
              <video
                className="w-full h-48 object-cover rounded-lg mb-4"
                src="https://static.vecteezy.com/system/resources/previews/053/656/221/mp4/an-office-worker-scans-a-sheet-of-a3-paper-on-a-scanner-video.mp4"
                controls
              />
              {/*<Link
                to="/services/printing"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link> */}
            </div>
          </div>

          {/* Graphic Design */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-2">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Graphic Design
              </h3>
              <p className="text-gray-600 mb-4">
                We create stunning graphic designs for all your needs, from logos
                to marketing materials. Explore our graphic design portfolio.
              </p>
              <img
                src="https://www.unite.ai/wp-content/uploads/2023/05/AI-Graphic-design-tools.png"
                alt="Graphic Design"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              {/*<Link
                to="/services/graphic-design"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link>*/}
            </div>
          </div>

          {/* Post-Matric Service */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
            <div className="px-2 py-2">
              <h3 className="text-2xl font-semibold text-blue-600 mb-3">
                Post-Matric Service
              </h3>
              <div className="bg-gradient-to-br from-purple-50 to-orange-50 px-2 py-4 rounded-lg mb-4 min-h-[180px] flex items-center">
                <p className="text-gray-700 text-center animate-fade-in">
                  {listItems[currentIndex]}
                </p>
              </div>
              {/*<Link
                to="/services/post-matric"
                className="text-orange-500 font-medium hover:text-orange-600 transition"
              >
                Learn More →
              </Link>*/}
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default ServicesPage;